/* eslint-disable max-len */
import React from 'react';
import { Redirect, useParams } from 'wouter';
import { useObserver } from '../../CodesThatsGottaGoSomewhereElse';
import { LFC } from '../../Legacy';
import { UseLocationScope } from '../AppLocation';
import { useResolve } from '../Container';
import { AccountModel } from '../account/AccountModel';
import { AccountPage } from '../account/AccountPage';
import { PageLoader } from '../account/PageLoader';
import { NavigationModel } from '../account/navigation/NavigationModel';
import { useReturnLocation } from '../common/ReturnLocation';
import { WorkspaceModel } from '../dashboard/Models';
import { WorkspaceScope } from './WorkspaceScope';
import { WorkspaceSwitch } from './WorkspaceSwitch';

const UseWorkspaceLocation = () => {
    const { id, label } = useObserver(useResolve(WorkspaceModel));
    return <UseLocationScope name="workspace" value={id} label={label} />;
};

const usePotentialAlias = (input: string) => {
    if (input === 'library') {
        const account = useResolve(AccountModel);
        return account.workspaces.find(x => x.type === 'library')?.id ?? null;
    }
    return input;
};

const RedirectIfSpecialWorkspace: LFC<{ entityId: string }> = ({ entityId }) => {
    const { workspaces } = useResolve(NavigationModel);
    const folderId = entityId.startsWith('FO') ? entityId : '';
    const workspace = workspaces.find(w => w.id === entityId || !!w.folders.find(f => f.id === folderId));

    if (workspace?.type === 'default') {
        return <Redirect to={'/boards'} />;
    }

    if (workspace?.type === 'library') {
        return <Redirect to={`~/library/${folderId}`} />;
    }

    return null;
};

export const WorkspacePage = () => {
    const params = useParams<{ entityId: string, param: string }>();
    const entityId = usePotentialAlias(params.entityId);
    const param = params.param;
    useReturnLocation(`~/${entityId}`);
    return <AccountPage>
        <RedirectIfSpecialWorkspace entityId={entityId} />
        <WorkspaceScope loader={PageLoader} entityId={entityId}>
            <UseWorkspaceLocation />
            <WorkspaceSwitch entityId={entityId} param={param} />
            {/* <InvokeWelcomePopupIfApplicable /> */}
        </WorkspaceScope>
    </AccountPage>;
};
